import { styled, css } from '@mui/material';
import { NotificationsActive, Alarm, Check } from '@mui/icons-material';
import Markdown from 'components/Markdown';

interface MarkdownProps {
  showIcon: boolean;
}

export const Wrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;

  p {
    font-size: 16px;
    line-height: 1.3;
    margin: 0;
  }
`;

export const StyledMarkdown = styled(Markdown)<MarkdownProps>`
  width: ${({ showIcon }) => (showIcon ? '100%' : '85px')};
`;

const iconStyles = css`
  font-size: 20px;
  margin-right: 5px;
`;

export const AlertIcon = styled(NotificationsActive)`
  ${iconStyles};
  font-size: 16px;
  margin-bottom: -3px;
`;

export const AlarmIcon = styled(Alarm)`
  ${iconStyles};
`;

export const CheckIcon = styled(Check)`
  ${iconStyles};
`;
